import 'remodal';
import HeaderNav from 'components/header-nav';
import loaderHtml from 'components/loader';
import Events from 'components/events';
import People from 'components/people';
import { apiUrl } from 'config/constants';
import { initFBComments, setMetaData, newFriendlyUrlParam, redirect } from 'utils/helpers';
import ImageTools from 'utils/imageTools';

'use strict';

const CityView = {
    /**
     * Initialize the view
     */
    init() {

        let name = newFriendlyUrlParam();

        if (name.includes('html')) {
            redirect('/');
        }

        if (name.includes('-')) {
            let testing = name.split('-');
            if (testing.length == 2) {
                this.cityName = `${testing[0]} ${testing[1]}`;
            }
            else if (testing.length > 2) {
                this.cityName = `${testing[0]} ${testing[1]} ${testing[2]}`;
            }
        }
        else {
            this.cityName = name;
        }

        if (!this.cityName || !this.cityName.length) {
            redirect('/');
        }

        initFBComments($('.js-fb-container'));

        $.material.init();

        this.$body = $('body');
        this.$body.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$newEvent = $('#new-event');
        this.$newEvent.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$newEventModal = this.$newEvent.remodal({ hashTracking: false });


        this.$body.removeClass('hidden').addClass('is-loading');
        HeaderNav.init({
            cityName: this.cityName
        }).then((success) => {
            if (success) {
                this.user = HeaderNav.me();
                this.userPermissions = HeaderNav.permissions();
                this.cityId = HeaderNav.getCity();
                this.userCity = HeaderNav.getCity();
                this.isCityMember = (this.userPermissions.isLoggedIn && this.user.cities.find((city) => (city.id === this.userCity[0].id))) || this.userPermissions.isAdmin;
                this.userPermissions.isManager = this.userPermissions.isManager && this.userCity[0].id === this.user.cities[0].id;


                setMetaData({ title: this.userCity[0].name });

                Events.init({
                    permissions: this.userPermissions,
                    me: this.user,
                    city: this.userCity[0],
                    isCityMember: this.isCityMember
                });
                People.init({
                    permissions: this.userPermissions,
                    me: this.user,
                    city: this.userCity[0],
                    isCityMember: this.isCityMember
                });

                if (!this.userPermissions.isManager) {
                    $('.js-open-new-event').remove();
                }
                if (!this.isCityMember) {
                    $('.js-show-all-users').remove();
                }

                $('.js-show-all-users').attr('href', `users/${this.cityName}`);
                $('.page-content').find('.js-city-name').text(this.userCity[0].name);

                let stringNameFB = this.userCity[0].name.replace(/\w\S*/g, (txt) => {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }).replace(/ /g, '');

                let stringNameMU = this.userCity[0].name.replace(/\w\S*/g, (txt) => {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }).replace(/ /g, '-');

                let fbLink = `https://www.facebook.com/groups/ML.${stringNameFB}`;

                if (this.userCity[0].name.toLowerCase() === 'montreal') {
                    fbLink = 'https://www.facebook.com/groups/ML.MTL';
                }
                else if (this.userCity[0].name.toLowerCase() === 'melbourne') {
                    fbLink = 'https://facebook.com/groups/ML.Melbourne.CBD';
                }

                $('.js-city-fb-link').attr('href', fbLink);
                $('.js-city-mu-link').attr('href', `https://www.meetup.com/Mundo-Lingo-${stringNameMU}`);
                this.loadData();
            }
            else {
                redirect('/');
            }
        });

        this.bindEvents();
    },

    getRequest() {
        if (!this.userPermissions.isLoggedIn) {
            return $.when(
                window.Api.User.getAll(new window.Api.City(this.cityName)),
                window.Api.Event.getAll(new window.Api.City(this.cityName))
            );
        }
        else {
            return $.when(
                window.Api.User.getAll(new window.Api.City(this.cityName)),
                window.Api.Event.getAll(new window.Api.City(this.cityName)),
                window.Api.Event.getAll(new window.Api.User(this.user.id))
            );
        }
    },

    loadData() {

        let cityN = this.userCity[0].name;
        this.getRequest().then((users, events, myEvents) => {
            this.$body.removeClass();

            if (users.isOk && events.isOk && ((this.userPermissions.isLoggedIn && myEvents.isOk) || !this.userPermissions.isLoggedIn)) {
                let eventsList = events.data.map((event) => {
                    event.city = cityN;
                    event.who = true;
                    if (this.userPermissions.isLoggedIn) {
                        myEvents.data.forEach((myevent) => {
                            if (myevent.id == event.id) {
                                event.registered = true;
                            }
                        });
                    }

                    return event;
                });

                let usersList = users.data.filter((user) => {
                    return user.role_type != 1;
                }).sort((a, b) => {
                    return a.role_type - b.role_type;
                });

                eventsList = eventsList.sort((e1, e2) => {
                    let hour1 = parseInt(e1.time.split(':')[0]);
                    let hour2 = parseInt(e2.time.split(':')[0]);
                    let minutes1 = parseInt(e1.time.split(':')[1]);
                    let minutes2 = parseInt(e2.time.split(':')[1]);

                    return e1.day_of_week > e2.day_of_week ? 1 : (e1.day_of_week < e2.day_of_week ? -1 : (hour1 > hour2 ? 1 : (hour1 < hour2 ? -1 : (minutes1 > minutes2 ? 1 : -1))));
                });

                this.renderUsers(usersList);
                this.renderEvents(eventsList);
                this.$body.removeClass('is-loading');
            }
            else {
                redirect('/');
            }
        }, () => {
            redirect('/');
        });
    },

    renderEvents(events) {
        let $events = Events.getEvents(events);

        $('.js-events-list').append($events);
    },

    renderUsers(users) {
        let $users = People.getPeople(users);

        $('.js-people-list').append($users);
    },

    openNewEvent(e) {
        e.preventDefault();
        this.$newEventModal.open();
    },

    closeNewEvent(e) {
        e.preventDefault();
        this.$newEventModal.close();
    },

    /**
     * Handle change event of file input
     * @param e {Event} change event object
     */
    handleUpload(e) {

        let file = e.target.files[0],
            $field = $(e.target),
            fileName = e.target.files[0].name,
            lastModifiedDate = new Date(e.target.files[0].lastModified),
            lastModified = e.target.files[0].lastModified,
            reader = new FileReader(),
            image = new Image();

        this.$newEvent.addClass('is-loading');
        reader.readAsDataURL(file);

        reader.onload = function a(e) {
            image.src = e.target.result;

            image.onload = function b() {

                let imageHeight = this.height;
                let imageWidth = this.width;

                if (imageHeight > 800 || imageWidth > 800) {
                    ImageTools.resize(file, {
                        width: 800,
                        height: 800
                    }, function a(blob, didItResize) {
                        blob.name = fileName;
                        blob.lastModified = lastModified;
                        blob.lastModifiedDate = lastModifiedDate;
                        CityView.uploadRequest(blob, $field, fileName);
                    });
                }
                else {
                    CityView.uploadRequest(file, $field, fileName);
                }
            };
        };
    },

    /**
     * Async upload request
     * @param file {File}
     * @param $field {jQuery} file input node
     */
    uploadRequest(file, $field, name) {
        let formData = new FormData();

        formData.append('file', file, name);
        $.ajax({
            url: apiUrl + 'images/upload',
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            type: 'post',
            xhrFields: {
                withCredentials: true
            },
            success: (res) => {
                this.$newEvent.removeClass('is-loading');
                this.$newEvent.find('.js-new-event-image-url').val(res);
            },
            error: () => {
                this.$newEvent.removeClass('is-loading');
                this.$newEvent.find('.js-new-event-image-url').val('');
            }
        });
    },


    handleNewEventSubmit(e) {
        e.preventDefault();

        let values = {
            image: $('.js-new-event-image-url').val(),
            'day_of_week': $('[name=new-event-day]:checked').val(),
            place: $('#new-event-name').val(),
            'street_address': $('#new-event-address').val(),
            neighborhood: $('#new-event-neighborhood').val(),
            province: $('#new-event-province').val(),
            'post_code': $('#new-event-post-code').val(),
            time: $('#new-event-time').val(),
            'contact_name': $('#new-event-cname').val(),
            'contact_phone': $('#new-event-cnumber').val(),
        };

        let hasError = false;

        for (let i in values) {
            if (values.hasOwnProperty(i)) {
                if (values[i]) {
                    values[i] = values[i].trim();
                }

                if (!values[i] || !values[i].length) {
                    hasError = true;
                }
            }
        }

        values['city_id'] = parseInt(this.cityId[0].id);
        values['day_of_week'] = parseInt(values.day_of_week);

        if (hasError) {
            $.snackbar({ content: 'All fields are required!' });
            return;
        }

        this.$newEvent.addClass('is-loading');

        window.Api.Event.createOne(values).then((res) => {
            this.$newEvent.removeClass('is-loading');

            if (res.isOk) {
                redirect(`/city/${this.cityName}`);
            }
            else {
                $.snackbar({ content: 'We couldn\'t save you event please try again later!' });
            }
        }, () => {
            this.$newEvent.removeClass('is-loading');
            $.snackbar({ content: 'We couldn\'t save you event please try again later!' });
        });
    },

    bindEvents() {
        $('.js-open-new-event').on('click', this.openNewEvent.bind(this));
        this.$newEvent.on('click', '.js-close-new-event', this.closeNewEvent.bind(this));
        this.$newEvent.on('change', 'input[type=\'file\']', this.handleUpload.bind(this));
        this.$newEvent.on('submit', '#new-event-form', this.handleNewEventSubmit.bind(this));
    }
};

/* start-test */
/* istanbul ignore if  */
if (!window.__karma__) {
    /* end-test */
    CityView.init();
    /* start-test */
}

/* end-test */
export default CityView;
